"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
const react_1 = __importDefault(require("react"));
const pad_1 = __importDefault(require("./pad"));
const utils_1 = require("./utils");
const Layer = ({ layer, z }) => {
    console.log("layer", layer);
    const text = layer.text.map((x, i) => {
        var _a, _b, _c;
        return ((react_1.default.createElement("text", { key: i, x: x.at.x, y: x.at.y, style: { fontSize: (((_c = (_b = (_a = x.effects) === null || _a === void 0 ? void 0 : _a.font) === null || _b === void 0 ? void 0 : _b.size) === null || _c === void 0 ? void 0 : _c.height) * 100) || "154" }, dominantBaseline: "middle", textAnchor: "middle", className: "fonty", color: layer.color, fill: layer.color }, x.value)));
    });
    const shapes = layer.shapes.map((x, i) => {
        // console.log("width: ", x.width)
        switch (x.type) {
            case "fp_line":
                return (react_1.default.createElement("line", { key: i, x1: x.start[0], y1: x.start[1], x2: x.end[0], y2: x.end[1], stroke: layer.color, strokeWidth: (x.width && Math.max(x.width, 25)) || "0.025" }));
            case "fp_arc":
                let end = utils_1.rotate(x.center, x.end, x.angle);
                let r = utils_1.len(x.center, x.end);
                // alert(`${x.center[0]},${x.center[1]} ${x.end[0]},${x.end[1]} ${end[0]},${end[1]} `)
                // alert(x.angle)
                return (react_1.default.createElement("path", { key: i, d: `M ${x.end[0]} ${x.end[1]} A ${r} ${r} 0 ${Math.abs(x.angle) > 180 ? 1 : 0} ${x.angle > 0 ? 1 : 0} ${end[0]} ${end[1]}`, fill: "none", stroke: layer.color, strokeWidth: (x.width && Math.max(x.width, 25)) || "0.025" }));
            case "fp_circle":
                return (react_1.default.createElement("circle", { key: i, cx: x.center[0], cy: x.center[1], r: utils_1.len(x.center, x.end), strokeWidth: (x.width && Math.max(x.width, 25)) || "0.025", fill: layer.color, stroke: "yellow" }));
            case "fp_poly":
                let inner_string = x.points.map(x => `${x[0]},${x[1]}`).join(" L ");
                return (react_1.default.createElement("path", { key: i, d: `M ${inner_string}`, stroke: layer.color, strokeWidth: (x.width && Math.max(x.width, 25)) || "0.025" }));
            case "fp_curve":
                return (react_1.default.createElement("path", { key: i, d: `M ${x.start[0]},${x.start[1]}  C ${x.control1[0]},${x.control1[1]} ${x.control2[0]},${x.control2[1]} ${x.end[0]},${x.end[1]}`, stroke: layer.color, strokeWidth: (x.width && Math.max(x.width, 25)) || "0.025" }));
            default:
                console.log("unhandled shape in layer: " + JSON.stringify(x));
                return null;
        }
    });
    return (react_1.default.createElement("g", { z: z },
        layer.pads.map(x => react_1.default.createElement(pad_1.default, { pad: x, color: layer.color })),
        shapes,
        text));
};
exports.Layer = Layer;
exports.default = exports.Layer;
